import type { BacklogHttpResponse } from "../contracts/api/BacklogHttpResponse";
import type { BacklogHttpFetcher as BacklogHttpFetcherContracts } from "../contracts/utils/BacklogHttpFetcher";
import { assert, resolveBacklogContainer } from "./BacklogUtil";

export class BacklogHttpFetcher implements BacklogHttpFetcherContracts {
	async fetch(url: URL, options: object): Promise<BacklogHttpResponse> {
		assert(url);
		assert(options);

		const fetch_response = await fetch(url, options);

		const response = resolveBacklogContainer("BacklogHttpResponse", {
			response: fetch_response,
		});
		assert(response);

		return response;
	}
}
